import React from 'react';

// Styles & Assets
import styles from './VisitRoutes.module.css';
import imgMap from './../../../assets/icons/sad-map.svg';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useEffect, useState } from 'react';
import useHttp from '../../../hooks/useHttp';

// Components
import RouteGeneralSlot from '../RouteGeneralSlot/RouteGeneralSlot';
import ErrorSpinnerWrapper from '../../UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

// Interfaces
import { Route } from '../../../interfaces/routes';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';
import { sortByAttribute } from '../../../services/sort';

const VisitRoutes: React.FC = () => {

    const { t } = useTranslation();

    const [routes, setRoutes] = useState<Route[]>([]);

    const { isLoading, error, sendRequest: sendRequestRoutes } = useHttp<Route[]>();

    useEffect(() => {
        sendRequestRoutes({
            url: getEnvironmentApiUrl() + 'route/all',
            method: 'POST',
            body: { params: {}, filter: {} },
        }, (data) => setRoutes(data));
    }, [sendRequestRoutes]);

    const deleteRoute = (id: number) => {
        setRoutes(oldRoutes => oldRoutes.filter(route => route.id !== id));
    };

    return (
        <div className={styles.visitRoutesContainer}>
            <div className={styles.newRouteContainer}>
                <img src={imgMap} className={styles.mapImg} alt='map'></img>
                <div>
                    <Link to={'/home/routes/generate_new_route'} className={`${styles.generateRouteButton} anchorButton`}>
                        <span>{t('generate_new_route')}</span>
                    </Link>
                </div>
            </div>    
            {routes.length>0?
                <div className={styles.availableRoutesContainer}>
                    <h2 className={styles.titleAvailableRoutes}>{t('available_routes')}</h2>
                    <div className={styles.availableRoutes}>
                        <ErrorSpinnerWrapper
                            error={error}
                            loading={isLoading}>
                            <>
                                {sortByAttribute(routes, 'date', false).map(route => {
                                    return (
                                        <RouteGeneralSlot
                                            key={route.id}
                                            route={route}
                                            deleteRoute={deleteRoute}
                                        />
                                    );
                                })
                                }
                            </>
                        </ErrorSpinnerWrapper>
                    </div>
                </div> :
                <></>
            }
        </div>
    );
};

export default VisitRoutes;